import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full py-0 px-3 mb-3 h-9 flex justify-between items-center text-gray-800" }
const _hoisted_2 = { class: "text-lg flex items-baseline" }
const _hoisted_3 = { class: "w-56" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_side_avatar = _resolveComponent("side-avatar")!
  const _component_f_icon = _resolveComponent("f-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_side_avatar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_f_icon, {
        name: "left",
        height: 16,
        width: 12,
        class: _normalizeClass(`text-primary ${_ctx.hideLeft ? 'opacity-0' : 'cursor-pointer'}`),
        onClick: _ctx.handleClickLeft
      }, null, 8, ["class", "onClick"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.semester), 1),
      _createVNode(_component_f_icon, {
        name: "right",
        height: 16,
        width: 12,
        class: _normalizeClass(`text-primary ${_ctx.hideRight ? 'opacity-0' : 'cursor-pointer'}`),
        onClick: _ctx.handleClickRight
      }, null, 8, ["class", "onClick"])
    ]),
    _createElementVNode("div", {
      class: "flex items-center f-clickable text-primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click-menu-button')))
    }, [
      _createVNode(_component_f_icon, {
        name: "menu-button",
        size: "24"
      })
    ])
  ]))
}